export default "__VITE_PUBLIC_ASSET__fbd7c559__"